import PropTypes from 'prop-types';
// @mui
import { styled, alpha } from '@mui/material/styles';
import { Toolbar, Typography, OutlinedInput, InputAdornment } from '@mui/material';
import * as XLSX from 'xlsx';

// component
import Iconify from '../../../components/iconify';
/* import BaseColor from '../../../BaseColor'; */
import apiFunctions from '../../../API/api';

// ----------------------------------------------------------------------

const StyledRoot = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(0, 1, 0, 3),
}));

const StyledSearch = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  '&.Mui-focused': {
    width: 320,
    boxShadow: theme.customShadows.z8,
  },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${alpha(theme.palette.grey[500], 0.32)} !important`,
  },
}));

// ----------------------------------------------------------------------

UserListToolbar.propTypes = {
  numSelected: PropTypes.number,
  filterName: PropTypes.string,
  onFilterName: PropTypes.func,
  tableType: PropTypes.string,
};

export default function UserListToolbar({ numSelected, filterName, onFilterName, tableType }) {
  const handleDownload = async () => {
    try {
      const data = await apiFunctions.getUserDetails();
      // response.data; // Replace with the data from your API

      // Specify the columns you want in the Excel file
      const columns = [
        { label: 'ID', value: 'ID' },
        { label: 'GVID', value: 'GVID' },
        { label: 'UserName', value: 'UserName' },
        { label: 'MobileNumber', value: 'MobileNumber' },
        { label: 'LocationCode', value: 'LocationCode' },
        { label: 'StoreID', value: 'StoreID' },
        { label: 'Redeemed', value: 'Redeemed' },
        { label: 'CreatedAt', value: 'CreatedAt' },
      ];

      // Convert data to worksheet

      const worksheet = XLSX.utils.json_to_sheet(data); // removed {header: columns} after, data
      // Create a new workbook and add the worksheet to it
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'User Details');

      // Generate a binary string from the workbook
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

      // Create a Blob from the buffer and download the file
      const blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Mia_GV_Details.xlsx';
      a.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading Excel:', error);
    }
  };
  return (
    <StyledRoot
      sx={{
        ...(numSelected > 0 && {
          color: 'primary.main',
          bgcolor: 'primary.lighter',
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography component="div" variant="subtitle1">
          {numSelected} selected
        </Typography>
      ) : (
        <StyledSearch
          value={filterName}
          onChange={onFilterName}
          placeholder={`Search ${tableType}...`}
          startAdornment={
            <InputAdornment position="start">
              <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled', width: 20, height: 20 }} />
            </InputAdornment>
          }
        />
      )}

      {/* {tableType === 'user' && (
        <Tooltip title="Download table">
          <IconButton
            onClick={() => {
              handleDownload();
            }}
          >
            <Iconify icon="eva:download-outline" color={BaseColor} />
          </IconButton>
        </Tooltip>
      )} */}
    </StyledRoot>
  );
}
